import { api, IFindAllRepository, ISelectRepository } from "../@vendor/utils";
import { Expertise } from "../models/Expertise";
import { createCancelTokenHandler } from "../@vendor/utils/services/cancel-token.service";

const endPoint = () => window._env_.REACT_APP_PASSPORT_END_POINT;

interface IRepository<T> extends IFindAllRepository<T>, ISelectRepository<T> { }

const Repository: IRepository<Expertise> = {
  findAll: function (params) {
    return api.get(`${endPoint()}/api/expertise`, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.findAll.name].handleRequestCancellation()
          .token,
    });
  },
  select: function (params) {
    return api.get(`${endPoint()}/api/expertise`, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.select.name].handleRequestCancellation()
          .token,
    });
  },
};

const cancelTokenHandlerObject = createCancelTokenHandler(Repository);

export default Repository;
